module.exports = __webpack_public_path__ + "static/img/landlord.faf147f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/aboutUs/landlord.png
// module id = dAZT
// module chunks = 30